import React, { useContext } from "react";
import classnames from "classnames";
import faqHeaderStyle from "./FaqHeader.module.scss";
import { AppContext } from "@vahak/core/dist/app-context";
import { useRouter } from "next/router";

// Services
import { FaqCateg } from "@vahak/core/dist/_services/faq.service";

// Component
import QuickFilterPill, { QuickFilterPillProps } from "@vahak/core/dist/components/quick-filter-pill/QuickFilterPill";
import ResponsiveContainer from "@vahak/core/dist/components/responsive-container/ResponsiveContainer";

// Icon
import ArrowDownBlue from "@vahak/core/dist/icons/ArrowDownBlue.svg";
import { FaqCategories } from "@vahak/core/dist/constants/Faq";

import AppBtn from "@vahak/core/dist/components/app-btn/AppBtn";

export interface FaqHeaderProps {
    heading: string;
    subHeading: string;
    handleCategorySelect: any;
    selectedFaqCateg: any;
}

const FaqHeader = ({ heading, subHeading, handleCategorySelect, selectedFaqCateg }: FaqHeaderProps) => {
    const { isMobile } = useContext(AppContext);

    const onSelectFaqCateg: QuickFilterPillProps<FaqCateg>["onSelected"] = async (item) => {
        handleCategorySelect({ categ: item });
    };

    const router = useRouter();

    return (
        <>
            <section className={classnames(faqHeaderStyle.section)}>
                <div className={classnames(faqHeaderStyle.header_layout, "container")}>
                    <div>
                        <h1 className={classnames(faqHeaderStyle.heading)}>{heading}</h1>
                        <h2 className={classnames(faqHeaderStyle.subHeading)}>{subHeading}</h2>
                    </div>
                    <div
                        className={classnames(faqHeaderStyle.category_card, `${isMobile ? faqHeaderStyle.mobile : ""}`)}
                    >
                        {isMobile ? (
                            <div className={faqHeaderStyle.faqDropDownBox}>
                                <select
                                    onChange={(e) => {
                                        e.persist();
                                        onSelectFaqCateg(
                                            FaqCategories.find((c) => c.slug === e.target.value) || selectedFaqCateg
                                        );
                                        router.push(
                                            `/frequently-asked-questions/[params]`,
                                            `/frequently-asked-questions/${
                                                e.target.value === FaqCategories[0]?.slug ? "" : e.target.value
                                            }`
                                        );
                                    }}
                                >
                                    {FaqCategories.map((category) => (
                                        <option
                                            key={category.slug}
                                            value={category.slug}
                                            selected={selectedFaqCateg.slug === category.slug}
                                        >
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                                <span className={faqHeaderStyle.iconDownArrow}>
                                    <ArrowDownBlue />
                                </span>
                            </div>
                        ) : (
                            <ResponsiveContainer className={classnames(faqHeaderStyle.category_pills_container)}>
                                {FaqCategories?.map(({ name, slug }) => (
                                    <AppBtn key={slug} type="link" className={faqHeaderStyle.categoryButtonContainer}>
                                        <QuickFilterPill
                                            className={faqHeaderStyle.categoryButton}
                                            text={name}
                                            data={{ name, slug }}
                                            isSelected={selectedFaqCateg.slug === slug}
                                            selectedClassName={faqHeaderStyle.selectedCategory}
                                            onSelected={onSelectFaqCateg}
                                        />
                                    </AppBtn>
                                ))}
                            </ResponsiveContainer>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default FaqHeader;
